import NoticeUpdate from "../components/pages/Notice/NoticeUpdate";

export default function NoticeUpdatePage() {
  return (
    <>
      <NoticeUpdate />
    </>
  );
}
